export class SpSadtRequestedProcedure {
    public idSpSsadtRequestedProcedure: number;
    public idSpSadtGuide: number;
    public idPriceProcedureHealthcare: number;
    public idPriceProcedurePlan: number;
    public requestedQuantityProcedureServiceItem: number;
    public authorizedQuantityProcedureServiceItem: number;
    public datetimeInclusion: Date;
}